// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bcb396f6","952":"124434cb"}[chunkId] + ".chunk.js";
};